import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import type { Challenge } from '../types'

const CATEGORY_COLORS = {
  VIDEO: 'bg-red-100 text-red-800',
  PHOTO: 'bg-blue-100 text-blue-800',
  DESSIN: 'bg-yellow-100 text-yellow-800',
  MUSIQUE: 'bg-purple-100 text-purple-800',
  AUTRE: 'bg-gray-100 text-gray-800',
} as const

const DIFFICULTY_COLORS = {
  FACILE: 'bg-green-100 text-green-800',
  MOYEN: 'bg-yellow-100 text-yellow-800',
  DIFFICILE: 'bg-red-100 text-red-800',
} as const

interface ChallengeCardProps {
  challenge: Challenge
  onParticipate: (challengeId: string) => void
}

export function ChallengeCard({ challenge, onParticipate }: ChallengeCardProps) {
  const deadline = new Date(challenge.deadline)
  const isExpired = deadline < new Date()

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-6">
        <div className="flex justify-between items-start">
          <div className="space-y-1">
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${CATEGORY_COLORS[challenge.category]}`}>
              {challenge.category}
            </span>
            <span className={`ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${DIFFICULTY_COLORS[challenge.difficulty]}`}>
              {challenge.difficulty}
            </span>
          </div>
          <span className="text-sm font-medium text-indigo-600">{challenge.points} points</span>
        </div>
        
        <h3 className="mt-4 text-lg font-medium text-gray-900">{challenge.title}</h3>
        <p className="mt-2 text-sm text-gray-500">{challenge.description}</p>
        
        <div className="mt-4">
          <p className="text-sm text-gray-500">
            Deadline: {format(deadline, 'PPP', { locale: fr })}
          </p>
        </div>

        <button
          onClick={() => onParticipate(challenge.id)}
          disabled={isExpired}
          className={`mt-4 w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white 
            ${isExpired 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
        >
          {isExpired ? 'Terminé' : 'Participer'}
        </button>
      </div>
    </div>
  )
}